import { IIsShowBlackFridayEtazhiResponse } from 'shared/repositories/mortgage-subsidised-offers/entities/is_show_black_friday_etazhi/IsShowBlackFridayEtazhiResponse';

export const mapResponse200 = (data: IIsShowBlackFridayEtazhiResponse): boolean => {
  return Boolean(data.showBlackFridayEtazhi);
};
